import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {ConfigValidationFunction, AdditionalConfigValidationFunctions} from '../StepConfigValidationTypes';
import * as Helpers from './StepConfigValidationHelpers';

const validateConfig: ConfigValidationFunction<PipelineStepType.HIDE_COLUMNS, 0> = (
  config,
  {'Input dataset': [dataFrameSpec]}
) =>
  Helpers.coalesceMessages(
    Helpers.getDuplicateColumnsMessage(
      dataFrameSpec,
      config.columns,
      'Cannot hide the same column more than once.'
    ),
    Helpers.getDuplicateColumnsMessage(
      dataFrameSpec,
      config.columnsToKeep,
      'Cannot keep the same column more than once.'
    ),
    config.columns.length > 0 && config.columnsToKeep.length > 0
      ? 'Columns to hide and columns to keep cannot be set at the same time.'
      : null,
    config.columns.length >= 1 || config.columnsToKeep.length >= 1
      ? null
      : 'Must hide or keep at least one column.'
  );

export default {
  stepType: PipelineStepType.HIDE_COLUMNS,
  stepVersion: 0,
  validateConfig,
} satisfies AdditionalConfigValidationFunctions<PipelineStepType.HIDE_COLUMNS, 0>;
